export const ROLES = {
  ATTENDEE: 'Attendee',
  ANALYST: 'Analyst',
  SUPER_ADMIN: 'SuperAdmin',
};

export const permissions = [ROLES.ATTENDEE, ROLES.ANALYST, ROLES.SUPER_ADMIN];

export const PERSON_TYPES = {
  CLIENT: 'client',
  SPECIALIST: 'specialist',
};

export const defaultPermission = ROLES.ANALYST;



// WEBPACK FOOTER //
// ./config/authentication.js